import { render, staticRenderFns } from "./multi-language.vue?vue&type=template&id=2eb2ed0f&scoped=true&"
import script from "./multi-language.vue?vue&type=script&lang=ts&"
export * from "./multi-language.vue?vue&type=script&lang=ts&"
import style0 from "./multi-language.vue?vue&type=style&index=0&id=2eb2ed0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb2ed0f",
  null
  
)

export default component.exports